import Vue from "vue";
import router from "vue-router";
import {MessageBox} from 'element-ui'

Vue.use(router);

import index from "../view/index.vue";
import Cookies from "js-cookie";
// 登录
const login = () => import("../view/login.vue");
// 登录 —— 账号已注册
const loginAccu = () => import("../view/loginAccu.vue")
// 海报页面
const poster = () => import("../view/poster.vue")
// 首页
const home = () => import("../view/home/index");
const personjob = () => import("../view/home/personjob.vue");
// 直聊
const directChat = () => import("../view/home/directChat.vue")
// 找回密码
const retrievePassword = () => import("../view/home/retrievePassword.vue")
// 招聘会
const jobfair = () => import("../view/jobfair");
const recruitment = () => import("../view/jobfair/recruitment.vue");
const consult = () => import('../view/jobfair/consult.vue')
const sceneInfo = () => import("../view/jobfair/sceneInfo.vue")
const networkInfo = () => import('../view/jobfair/networkInfo.vue')

const employment = () => import("../view/home/employment.vue");
const headfairmain = () => import("../view/home/headfairmain.vue");

const ganhuman = () => import("../view/home/ganhuman.vue");

//中小企业
const nsmep = () => import("../view/home/nsmep.vue");

const jobrefer = () => import("../view/home/jobrefer.vue");
const product = () => import("../view/home/product.vue");
//意见反馈
const feedback = () => import('../view/home/feedback.vue');
const selfhelp = () => import('../components/home/feedback/selfhelp.vue');
const feedlist = () => import('../components/home/feedback/feedlist.vue');
// 资讯详情
const newsinfo = () => import("../view/info/newsinfo.vue");
// 个人求职详情
const jobinfo = () => import("../view/info/jobinfo.vue");
// 招考培训详情
const trainDetails = () => import("../view/info/trainDetails.vue");
//猎头招聘详情
const headfairinfo = () => import("../view/info/headfairinfo.vue");
// 猎头招聘的子路由
const headfair = () => import("../view/home/headfair/headfair.vue");
const headfairRpo = () => import("../view/home/headfair/headfairRpo.vue");
const talentAssessment = () => import("../view/home/headfair/talentAssessment.vue");
const baicaiHeadhunting = () => import("../view/home/headfair/baicaiHeadhunting.vue")
const reference = () => import("../view/home/headfair/reference.vue")
const rpo = () => import("../view/home/headfair/rpo.vue")
// 公司简介
const firminfo = () => import("../view/info/firminfo.vue");
// 个人注册
const nomRegister = () => import("../view/home/nomRegister.vue");
// 企业注册
const firmRegister = () => import("../view/home/firmRegister.vue");
// 个人中心
const mine = () => import("../view/mine.vue");
const mineCenter = () => import("../view/mine/center.vue");
const mineMassages = () => import("../view/mine/massage.vue");
const mineAC = () => import("../view/mine/ac.vue");
const mineAccount = () => import("../view/mine/account");
const minePassword = () => import("../view/mine/password");
const mineResume = () => import("../view/mine/resume.vue");
const mineOutsource = () => import("../view/mine/outsource");
const mineOpen = () => import("../view/mine/open");
const mineJob = () => import("../view/mine/job.vue");
const mineCheck = () => import("../view/mine/check.vue");
const mineQcResume = () => import("../view/mine/qcResume.vue");
const mineSearch = () => import("../view/mine/search.vue");
const minFacorites = () => import("../view/mine/facorites.vue");
const mineInterview = () => import("../view/mine/interview.vue");
const mineMap = () => import("../view/mine/map.vue");
const minePreview = () => import("../view/mine/components/previewResume.vue");
const mineintTask = () => import("../view/mine/integralTask.vue");
const mineExcServe = () => import("../view/mine/exchangeServe.vue");
const mineMyInt = () => import("../view/mine/myIntegral.vue");
const mineSerInd = () => import("../view/mine/serveIndent.vue");
const payment = () => import("../view/mine/payment.vue");
const mineOrder = () => import('../view/mine/order.vue');

//产品中心
const northperson = () => import("../components/home/product/northperson.vue");
const scene = () => import("../components/home/product/scene.vue");
const clientjob = () => import("../components/home/product/clientjob.vue");
const profession = () => import("../components/home/product/profession.vue");
// 帮助中心
const helpCenter = () => import("../view/home/helpCenter.vue");
const helpDetail = () => import("../view/home/helpDetail.vue");
// const helpDetail = () => import("../components/home/help/helpDetail.vue");
// 协议
const agreement = () => import("../view/home/agreement.vue");
// 企业中心
const enterprise = () => import("../view/enterprise.vue");
const enterpriseCenter = () => import("../view/enterprise/center.vue");
const instation = () => import("../view/enterprise/instation.vue");
const emailBoard = () => import("../view/enterprise/emailBoard.vue");
const subscription = () => import("../view/enterprise/subscription.vue");
const basicData = () => import("../view/enterprise/basicData.vue");
const accountMange = () => import("../view/enterprise/accountMange.vue");
const approveCenter = () => import("../view/enterprise/approveCenter.vue");
const resume = () => import("../view/enterprise/resume.vue");
const productBuy = () => import("../view/enterprise/productBuy.vue");
const serviceManage = () => import("../view/enterprise/serviceManage.vue");
const myOrder = () => import("../view/enterprise/myOrder.vue");
const deliver = () => import("../view/enterprise/deliver.vue");
const jobPublish = () => import("../view/enterprise/jobPublish.vue");
const resumeDown = () => import("../view/enterprise/resumeDown.vue");
const refresh = () => import("../view/enterprise/refresh.vue");
const confirmOrder = () => import("../view/enterprise/confirmOrder.vue");
const myIntegral = () => import("../view/enterprise/myIntegral.vue")
const serveOrder = () => import("../view/enterprise/serveOrder.vue")
const integratingTask = () => import("../view/enterprise/integratingTask.vue")
const exchangeService = () => import("../view/enterprise/exchangeService.vue")

const exchangeServes = () => import("../view/enterprise/exchangeServes.vue");

// 企业管理中心-->网络招聘中心
const network = () => import("../view/network.vue");
const networkCenter = () => import("../view/network/center.vue");
const postJob = () => import("../view/network/postJob.vue");
const jobList = () => import("../view/network/jobList.vue");
const jobTemplate = () => import("../view/network/jobTemplate.vue");
const netResume = () => import("../view/network/resume.vue");
const resumeSearch = () => import("../view/network/resumeSearch.vue");
// 企业管理中心-->现场招聘会
const sceneMeet = () => import("../view/sceneMeet.vue");
const sceneCenter = () => import("../view/sceneMeet/center.vue");
const boothBooking = () => import("../view/sceneMeet/boothBooking.vue");
const myBooth = () => import("../view/sceneMeet/myBooth.vue");
const pastBooth = () => import("../view/sceneMeet/pastBooth.vue");
const releaseJob = () => import("../view/sceneMeet/releaseJob.vue");
const sceneJobList = () => import("../view/sceneMeet/sceneJobList.vue");
const sceneJobListdel = () => import("../view/sceneMeet/sceneJobListdel.vue");
const receiveResume = () => import("../view/sceneMeet/receiveResume.vue");
const onlineInvitation = () => import("../view/sceneMeet/onlineInvitation.vue");
const serviceManagement = () => import("../view/sceneMeet/serviceManagement.vue");
const order = () => import("../view/sceneMeet/order.vue")
const orderSuccess = () => import("../view/sceneMeet/orderSuccess.vue")
// 电视大屏
const tv = () => import("../view/tv.vue")
const tvOne = () => import("../view/tvOne.vue")

//管理咨询
const ConsultingPage = () => import("../view/ConsultingPage/index.vue")

// 简历优化
const resumeTemplate = () => import("../view/home/resumeOptimization/index.vue")
const resumeOptimization = () => import("../view/home/resumeOptimization.vue")
const templateIndex = () => import("../view/home/resumeOptimization/template.vue")
const useTemplate = () => import("../view/home/resumeOptimization/useTemplate.vue")

//简历置顶
const resumeTop = () => import("../view/home/resumeTop.vue")

//获取原型对象上的push函数
const originalPush = router.prototype.push;
//修改原型对象中的push方法
router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};
const routers = new router({
    mode: "history",
    linkActiveClass: "active-nav", //激活样式
    routes: [{
        path: "/login",
        alias: "/l",
        name: "用户登录",
        component: login,
        meta: {
            isAuth: true
        }
    }, {
        path: "/poster",
        name: "海报",
        component: poster,
        meta: {
            isAuth: true
        }
    },
        {
            path: "/loginAccu",
            // alias: "/l",
            name: "as账号",
            component: loginAccu,
            meta: {
                isAuth: true
            }
        },
        {
            path: "/tv",
            name: "大屏海报",
            component: tv,
            meta: {
                isAuth: true
            }
        },
        {
            path: "/tvOne",
            name: "大屏海报",
            component: tvOne,
            meta: {
                isAuth: true
            }
        },

        {
            path: "/", //链接路径
            name: "前台", //路由名称
            alias: "/index", // redirect:"/",
            component: index, //对应组件模板,

            children: [{
                path: "/",
                name: "首页",
                component: home,
                meta: {
                    isAuth: true
                },
            },
                {
                    path: "resumeTop", //链接路径
                    name: "简历置顶", //路由名称
                    component: resumeTop,
                    meta: {
                        isAuth: true
                    },
                },
                {
                    path: "personjob", //链接路径
                    name: "个人求职", //路由名称
                    component: personjob,
                    meta: {
                        isAuth: true
                    },
                },
                {
                    path: "retrievePassword",
                    name: "找回密码",
                    component: retrievePassword,
                    meta: {
                        isAuth: true
                    },
                },
                {
                    path: "directChat", //链接路径
                    name: "直聊", //路由名称
                    component: directChat,
                    meta: {
                        isAuth: true
                    },
                },
                {
                    path: "jobfair", //链接路径
                    name: "招聘会", //路由名称
                    redirect: "/jobfair/recruitment",
                    component: jobfair,
                    meta: {
                        isAuth: true
                    },
                    children: [{
                        path: "recruitment", //链接路径
                        name: "招聘会", //路由名称
                        component: recruitment,
                        meta: {
                            isAuth: true
                        },
                    },
                        {
                            path: "sceneInfo", //链接路径
                            name: "现场招聘会详情", //路由名称
                            component: sceneInfo,
                            meta: {
                                isAuth: true
                            },
                        },
                        {
                            path: "sceneInfo2", //链接路径
                            name: "现场招聘会详情", //路由名称
                            component: () => import("@/view/jobfair/sceneInfo2.vue"),
                            meta: {
                                isAuth: true
                            },
                        },
                        {
                            path: "jobfairEnterprise", //链接路径
                            name: "招聘会企业详情", //路由名称
                            component: () => import("@/view/jobfair/jobfairEnterprise.vue"),
                            meta: {
                                isAuth: true
                            },
                        },
                        {
                            path: "enterpriseDetail", //链接路径
                            name: "招聘会职位详情", //路由名称
                            component: () => import("@/view/jobfair/enterpriseDetail.vue"),
                            meta: {
                                isAuth: true
                            },
                        },
                        {
                            path: "networkInfo", //链接路径
                            name: "网络招聘会详情", //路由名称
                            component: networkInfo,
                            meta: {
                                isAuth: true
                            },
                        },
                        {
                            path: "consult", //链接路径
                            name: "查阅", //路由名称
                            component: consult,
                            meta: {
                                isAuth: true
                            },
                        },
                    ],
                },
                {
                    path: "employment", //链接路径
                    name: "招考专栏", //路由名称
                    component: employment,
                    meta: {
                        isAuth: true
                    },
                },
                {
                    path: "headfair", //链接路径
                    name: "佰才速聘", //路由名称
                    component: headfair,
                    meta: {
                        isAuth: true
                    },
                },{
                    path: "ConsultingPage", //链接路径
                    name: "管理咨询", //路由名称
                    component: ConsultingPage,
                    meta: {
                        isAuth: true
                    },
                },
                {
                    path: "headfairmain", //链接路径
                    name: "猎头招聘", //路由名称
                    redirect: "/headfairmain/headfairRpo",
                    component: headfairmain,
                    meta: {
                        isAuth: true
                    },
                    children: [{
                        path: "headfairRpo", //链接路径
                        name: "交付RPO", //路由名称
                        component: headfairRpo,
                        meta: {
                            isAuth: true
                        },
                    },
                        {
                            path: "talentAssessment",
                            name: "人才测评",
                            component: talentAssessment,
                            meta: {
                                isAuth: true
                            },
                        },
                        {
                            path: "baicaiHeadhunting",
                            name: "陌材猎头",
                            component: baicaiHeadhunting,
                            meta: {
                                isAuth: true
                            },
                        },
                        {
                            path: "RPO",
                            name: "招聘流程外包（RPO）",
                            component: rpo,
                            meta: {
                                isAuth: true
                            },
                        },
                        {
                            path: "reference",
                            name: "背景调查",
                            component: reference,
                            meta: {
                                isAuth: true
                            },
                        },
                    ]
                },
                {
                    path: "ganhuman", //链接路径
                    name: "甘肃人力", //路由名称
                    component: ganhuman,
                    meta: {
                        isAuth: true
                    },
                },
                {
                    path: "jobrefer", //链接路径
                    name: "职场咨询", //路由名称
                    component: jobrefer,
                    meta: {
                        isAuth: true
                    },
                },
				{
					path: "nsmep", //链接路径
					name: "中小企业", //路由名称
					component: nsmep,
					meta: {
					    isAuth: true
					},
				},
                {
                    path: "product", //链接路径
                    name: "产品中心", //路由名称
                    redirect: "/product/northperson",
                    component: product,
                    meta: {
                        isAuth: true
                    },
                    children: [{
                        path: "/product/northperson",
                        name: "西北人才网",
                        component: northperson,
                        meta: {
                            isAuth: true
                        },
                    },
                        {
                            path: "/product/scene",
                            name: "现场服务会",
                            component: scene,
                            meta: {
                                isAuth: true
                            },
                        },
                        {
                            path: "/product/clientjob",
                            name: "委托招聘服务",
                            component: clientjob,
                            meta: {
                                isAuth: true
                            },
                        },
                        {
                            path: "/product/profession",
                            name: "职业培训服务",
                            component: profession,
                            meta: {
                                isAuth: true
                            },
                        },
                    ],
                },
                {
                    path: "helpCenter", //链接路径
                    name: "帮助中心", //路由名称
                    component: helpCenter, //对应组件模板
                    meta: {
                        isAuth: true
                    },
                },
                {
                    path: "helpDetail", //链接路径
                    name: "帮助中心", //路由名称
                    component: helpDetail, //对应组件模板
                    meta: {
                        isAuth: true
                    },
                },
                {
                    path: "agreement",
                    name: "协议",
                    component: agreement,
                    meta: {
                        isAuth: true
                    },
                },
                {
                    path: "nomRegister", //链接路径
                    name: "个人注册", //路由名称
                    component: nomRegister, //对应组件模板
                    meta: {
                        isAuth: true
                    },
                },
                {
                    path: "firmRegister", //链接路径
                    name: "企业注册", //路由名称
                    component: firmRegister, //对应组件模板
                    meta: {
                        isAuth: true,
                        keepAlive: true
                    },
                },
                {
                    path: "jobinfo",
                    name: "个人求职详情",
                    component: jobinfo,
                    meta: {
                        isAuth: true
                    },
                },
                {
                    path: "newsinfo",
                    name: "资讯详情",
                    component: newsinfo,
                    meta: {
                        isAuth: true
                    },
                },
                {
                    path: "firminfo",
                    name: "公司简介",
                    component: firminfo,
                    meta: {
                        isAuth: true
                    },
                },
                {
                    path: "headfairinfo",
                    name: "猎头招聘详情",
                    component: headfairinfo,
                    meta: {
                        isAuth: true
                    },
                },
                {
                    path: "confirmOrder",
                    name: "确认订单",
                    component: confirmOrder,
                    meta: {
                        isAuth: true,
                    },
                },
                {
                    path: "order", //链接路径
                    name: "订单支付", //路由名称
                    component: order,
                    meta: {
                        isAuth: true,
                    },
                },
                {
                    path: "orderSuccess", //链接路径
                    name: "支付成功", //路由名称
                    component: orderSuccess,
                    meta: {
                        isAuth: true,
                    },
                },
                {
                    path: "feedback",
                    name: "意见反馈",
                    component: feedback,
                    meta: {
                        isAuth: true
                    },
                    redirect: "/feedback/selfhelp",
                    children: [{
                        path: "selfhelp",
                        name: "意见反馈",
                        component: selfhelp,
                        meta: {
                            isAuth: true
                        },
                    },
                        {
                            path: "feedlist",
                            name: "反馈列表",
                            component: feedlist,
                            meta: {
                                isAuth: true
                            },
                        },
                    ]
                },
                {
                    path: "resumeOptimization", //链接路径
                    name: "简历优化", //路由名称
                    redirect: '/resumeOptimization/resumeTemplate',
                    component: resumeOptimization,
                    meta: {
                        isAuth: true,
                    },
                    children: [
                        {
                            path: "resumeTemplate", //链接路径
                            name: "简历优化", //路由名称
                            component: resumeTemplate,
                            meta: {
                                isAuth: true,
                            },
                        },
                        {
                            path: "/", //链接路径
                            name: "前台", //路由名称
                            alias: "/index", // redirect:"/",
                            component: index, //对应组件模板,

                            children: [{
                                path: "/",
                                name: "首页",
                                component: home,
                                meta: {
                                    isAuth: true
                                },
                            },
                                {
                                    path: "resumeTop", //链接路径
                                    name: "简历置顶", //路由名称
                                    component: resumeTop,
                                    meta: {
                                        isAuth: true
                                    },
                                },
                                {
                                    path: "personjob", //链接路径
                                    name: "个人求职", //路由名称
                                    component: personjob,
                                    meta: {
                                        isAuth: true
                                    },
                                },
                                {
                                    path: "retrievePassword",
                                    name: "找回密码",
                                    component: retrievePassword,
                                    meta: {
                                        isAuth: true
                                    },
                                },
                                {
                                    path: "directChat", //链接路径
                                    name: "直聊", //路由名称
                                    component: directChat,
                                    meta: {
                                        isAuth: true
                                    },
                                },
                                {
                                    path: "jobfair", //链接路径
                                    name: "招聘会", //路由名称
                                    redirect: "/jobfair/recruitment",
                                    component: jobfair,
                                    meta: {
                                        isAuth: true
                                    },
                                    children: [{
                                        path: "recruitment", //链接路径
                                        name: "招聘会", //路由名称
                                        component: recruitment,
                                        meta: {
                                            isAuth: true
                                        },
                                    },
                                        {
                                            path: "sceneInfo", //链接路径
                                            name: "现场招聘会详情", //路由名称
                                            component: sceneInfo,
                                            meta: {
                                                isAuth: true
                                            },
                                        },
                                        {
                                            path: "networkInfo", //链接路径
                                            name: "网络招聘会详情", //路由名称
                                            component: networkInfo,
                                            meta: {
                                                isAuth: true
                                            },
                                        },
                                        {
                                            path: "consult", //链接路径
                                            name: "查阅", //路由名称
                                            component: consult,
                                            meta: {
                                                isAuth: true
                                            },
                                        },
                                    ],
                                },
                                {
                                    path: "employment", //链接路径
                                    name: "招考专栏", //路由名称
                                    component: employment,
                                    meta: {
                                        isAuth: true
                                    },
                                },
                                {
                                    path: "headfairmain", //链接路径
                                    name: "猎头招聘", //路由名称
                                    redirect: "/headfairmain/headfair",
                                    component: headfairmain,
                                    meta: {
                                        isAuth: true
                                    },
                                    children: [{
                                        path: "headfair", //链接路径
                                        name: "猎头招聘", //路由名称
                                        component: headfair,
                                        meta: {
                                            isAuth: true
                                        },
                                    },
                                        {
                                            path: "talentAssessment",
                                            name: "人才测评",
                                            component: talentAssessment,
                                            meta: {
                                                isAuth: true
                                            },
                                        },
                                        {
                                            path: "baicaiHeadhunting",
                                            name: "陌材猎头",
                                            component: baicaiHeadhunting,
                                            meta: {
                                                isAuth: true
                                            },
                                        },
                                        {
                                            path: "RPO",
                                            name: "招聘流程外包（RPO）",
                                            component: rpo,
                                            meta: {
                                                isAuth: true
                                            },
                                        },
                                        {
                                            path: "reference",
                                            name: "背景调查",
                                            component: reference,
                                            meta: {
                                                isAuth: true
                                            },
                                        },
                                    ]
                                },
                                {
                                    path: "ganhuman", //链接路径
                                    name: "甘肃人力", //路由名称
                                    component: ganhuman,
                                    meta: {
                                        isAuth: true
                                    },
                                },
                                {
                                    path: "jobrefer", //链接路径
                                    name: "职场咨询", //路由名称
                                    component: jobrefer,
                                    meta: {
                                        isAuth: true
                                    },
                                },{
									path: "nsmep", //链接路径
									name: "中小企业", //路由名称
									component: nsmep,
									meta: {
									    isAuth: true
									},
								},
                                {
                                    path: "product", //链接路径
                                    name: "产品中心", //路由名称
                                    redirect: "/product/northperson",
                                    component: product,
                                    meta: {
                                        isAuth: true
                                    },
                                    children: [{
                                        path: "/product/northperson",
                                        name: "西北人才网",
                                        component: northperson,
                                        meta: {
                                            isAuth: true
                                        },
                                    },
                                        {
                                            path: "/product/scene",
                                            name: "现场服务会",
                                            component: scene,
                                            meta: {
                                                isAuth: true
                                            },
                                        },
                                        {
                                            path: "/product/clientjob",
                                            name: "委托招聘服务",
                                            component: clientjob,
                                            meta: {
                                                isAuth: true
                                            },
                                        },
                                        {
                                            path: "/product/profession",
                                            name: "职业培训服务",
                                            component: profession,
                                            meta: {
                                                isAuth: true
                                            },
                                        },
                                    ],
                                },
                                {
                                    path: "helpCenter", //链接路径
                                    name: "帮助中心", //路由名称
                                    component: helpCenter, //对应组件模板
                                    meta: {
                                        isAuth: true
                                    },
                                },
                                {
                                    path: "agreement",
                                    name: "协议",
                                    component: agreement,
                                    meta: {
                                        isAuth: true
                                    },
                                },
                                {
                                    path: "nomRegister", //链接路径
                                    name: "个人注册", //路由名称
                                    component: nomRegister, //对应组件模板
                                    meta: {
                                        isAuth: true
                                    },
                                },
                                {
                                    path: "firmRegister", //链接路径
                                    name: "企业注册", //路由名称
                                    component: firmRegister, //对应组件模板
                                    meta: {
                                        isAuth: true,
                                        keepAlive: true
                                    },
                                },
                                {
                                    path: "jobinfo",
                                    name: "个人求职详情",
                                    component: jobinfo,
                                    meta: {
                                        isAuth: true
                                    },
                                },
                                {
                                    path: "trainDetails",
                                    name: "招考培训详情",
                                    component: trainDetails,
                                    meta: {
                                        isAuth: true
                                    },
                                },
                                {
                                    path: "newsinfo",
                                    name: "资讯详情",
                                    component: newsinfo,
                                    meta: {
                                        isAuth: true
                                    },
                                },
                                {
                                    path: "firminfo",
                                    name: "公司简介",
                                    component: firminfo,
                                    meta: {
                                        isAuth: true
                                    },
                                },
                                {
                                    path: "headfairinfo",
                                    name: "猎头招聘详情",
                                    component: headfairinfo,
                                    meta: {
                                        isAuth: true
                                    },
                                },
                                {
                                    path: "confirmOrder",
                                    name: "确认订单",
                                    component: confirmOrder,
                                    meta: {
                                        isAuth: true,
                                    },
                                },
                                {
                                    path: "order", //链接路径
                                    name: "订单支付", //路由名称
                                    component: order,
                                    meta: {
                                        isAuth: true,
                                    },
                                },
                                {
                                    path: "orderSuccess", //链接路径
                                    name: "支付成功", //路由名称
                                    component: orderSuccess,
                                    meta: {
                                        isAuth: true,
                                    },
                                },
                                {
                                    path: "feedback",
                                    name: "意见反馈",
                                    component: feedback,
                                    meta: {
                                        isAuth: true
                                    },
                                    redirect: "/feedback/selfhelp",
                                    children: [{
                                        path: "selfhelp",
                                        name: "意见反馈",
                                        component: selfhelp,
                                        meta: {
                                            isAuth: true
                                        },
                                    },
                                        {
                                            path: "feedlist",
                                            name: "反馈列表",
                                            component: feedlist,
                                            meta: {
                                                isAuth: true
                                            },
                                        },
                                    ]
                                },
                                {
                                    path: "resumeTemplate", //链接路径
                                    component: resumeTemplate,
                                    name: "简历优化", //路由名称
                                    meta: {
                                        isAuth: true,
                                    },
                                },
                                {
                                    path: "resumeOptimization", //链接路径
                                    name: "简历模版", //路由名称
                                    redirect: "/resumeOptimization/templateIndex",
                                    component: resumeOptimization,
                                    meta: {
                                        isAuth: true
                                    },
                                    children: [
                                        {
                                            path: "templateIndex", //链接路径
                                            name: "简历模版", //路由名称
                                            component: templateIndex,
                                            meta: {
                                                isAuth: true,
                                            },
                                        },
                                        {
                                            path: "useTemplate", //链接路径
                                            name: "简历模版", //路由名称
                                            component: useTemplate,
                                            meta: {
                                                isAuth: true,
                                            },
                                        },]
                                },
                            ],
                            path: "templateIndex", //链接路径
                            name: "简历模版", //路由名称
                            component: templateIndex,
                            meta: {
                                isAuth: true,
                            },
                        },
                        {
                            path: "useTemplate", //链接路径
                            name: "简历模版", //路由名称
                            component: useTemplate,
                            meta: {
                                isAuth: true,
                            },
                        },
                    ]
                },
            ],
        },
        {
            path: "/mine", //链接路径
            name: "个人中心", //路由名称
            redirect: "/mine/center",
            component: mine, //对应组件模板
            children: [{
                path: "center",
                name: "个人管理中心",
                component: mineCenter,
                meta: {
                    isAuth: false,
                    type: 'mine'
                },
            },
                {
                    path: "preview",
                    name: "简历预览",
                    component: minePreview,
                    meta: {
                        isAuth: true,
                        type: 'mine'
                    },
                },

                {
                    path: "massages",
                    name: "我的消息",
                    component: mineMassages,
                    meta: {
                        isAuth: false,
                        type: 'mine'
                    },
                },
                {
                    path: "ac",
                    name: "认证中心/认证管理",
                    component: mineAC,
                    meta: {
                        isAuth: false,
                        type: 'mine'
                    },
                },
                {
                    path: "order",
                    name: "订单管理",
                    component: mineOrder,
                    meta: {
                        isAuth: false,
                        type: 'mine'
                    },
                },
                {
                    path: "account",
                    name: "认证中心/账号绑定",
                    component: mineAccount,
                    meta: {
                        isAuth: false,
                        type: 'mine'
                    },
                },
                {
                    path: "password",
                    name: "认证中心/密码管理",
                    component: minePassword,
                    meta: {
                        isAuth: false,
                        type: 'mine'
                    },
                },
                {
                    path: "resume",
                    name: "简历管理/我的简历",
                    component: mineResume,
                    meta: {
                        isAuth: false,
                        type: 'mine'
                    },

                },
                {
                    path: "outsource",
                    name: "简历管理/外发简历",
                    component: mineOutsource,
                    meta: {
                        isAuth: false,
                        type: 'mine'
                    },
                },
                {
                    path: "open",
                    name: "简历管理/公开设置",
                    component: mineOpen,
                    meta: {
                        isAuth: false,
                        type: 'mine'
                    },
                },
                {
                    path: "job",
                    name: "求职管理/我的求职记录",
                    component: mineJob,
                    meta: {
                        isAuth: false,
                        type: 'mine'
                    },
                },
                {
                    path: "check",
                    name: "求职管理/简历被查看记录",
                    component: mineCheck,
                    meta: {
                        isAuth: false,
                        type: 'mine'
                    },
                },
                {
                    path: "qcResume",
                    name: "求职管理/外发简历记录",
                    component: mineQcResume,
                    meta: {
                        isAuth: false,
                        type: 'mine'
                    },
                },
                {
                    path: "search",
                    name: "职位搜索",
                    component: mineSearch,
                    meta: {
                        isAuth: false,
                        type: 'mine'
                    },
                },
                {
                    path: "integralTask",
                    name: "会员服务/积分任务",
                    component: mineintTask,
                    meta: {
                        isAuth: false,
                        type: 'mine'
                    },
                },
                {
                    path: "exchangeServe",
                    name: "会员服务/兑换服务",
                    component: mineExcServe,
                    meta: {
                        isAuth: false,
                        type: 'mine'
                    },
                },
                {
                    path: "myIntegral",
                    name: "会员服务/我的积分",
                    component: mineMyInt,
                    meta: {
                        isAuth: false,
                        type: 'mine'
                    },
                },
                {
                    path: "serveIndent",
                    name: "会员服务/服务订单",
                    component: mineSerInd,
                    meta: {
                        isAuth: false,
                        type: 'mine'
                    },
                },
                {
                    path: "payment",
                    name: "订单支付",
                    component: payment,
                    meta: {
                        isAuth: false,
                        type: 'mine'
                    },
                },
                {
                    path: "facorites",
                    name: "职位收藏夹",
                    component: minFacorites,
                    meta: {
                        isAuth: false,
                        type: 'mine'
                    },
                },

                {
                    path: "map",
                    name: "就业E图",
                    component: mineMap,
                    meta: {
                        isAuth: false,
                        type: 'mine'
                    },
                },
                {
                    path: "interview",
                    name: "面试邀请/面试邀请记录",
                    component: mineInterview,
                    meta: {
                        isAuth: false,
                        type: 'mine'
                    },
                },

            ],
        }, // 企业中心
        {
            path: "/enterprise", //链接路径
            name: "企业中心", //路由名称
            redirect: "/enterprise/center",
            component: enterprise, //对应组件模板
            meta: {
                isAuth: true,
            },
            children: [{
                path: "center",
                name: "企业管理中心",
                component: enterpriseCenter,
                meta: {
                    isAuth: true,
                },
            },
                {
                    path: "exchangeServes",
                    name: "会员服务/兑换服务",
                    component: exchangeServes,
                    meta: {
                        isAuth: false,
                        type: 'company'
                    },
                },
                {
                    path: "instation",
                    name: "站内消息",
                    component: instation,
                    meta: {
                        isAuth: false,
                        type: 'company'
                    },
                },
                {
                    path: "emailBoard",
                    name: "邮件模板",
                    component: emailBoard,
                    meta: {
                        isAuth: false,
                        type: 'company'
                    },
                },
                {
                    path: "subscription",
                    name: "消息订阅",
                    component: subscription,
                    meta: {
                        isAuth: false,
                        type: 'company'
                    },
                },
                {
                    path: "basicData",
                    name: "基本资料",
                    component: basicData,
                    meta: {
                        isAuth: false,
                        type: 'company'
                    },
                },
                {
                    path: "accountMange",
                    name: "账户管理",
                    component: accountMange,
                    meta: {
                        isAuth: false,
                        type: 'company'
                    },
                },
                {
                    path: "approveCenter",
                    name: "认证中心",
                    component: approveCenter,
                    meta: {
                        isAuth: false,
                        type: 'company'
                    },
                },
                {
                    path: "resume",
                    name: "简历搜索",
                    component: resume,
                    meta: {
                        isAuth: false,
                        type: 'company'
                    },
                },
                {
                    path: "productBuy",
                    name: "产品购买",
                    component: productBuy,
                    meta: {
                        isAuth: false,
                        type: 'company'
                    },
                },
                {
                    path: "serviceManage",
                    name: "服务管理",
                    component: serviceManage,
                    meta: {
                        isAuth: false,
                        type: 'company'
                    },
                },
                {
                    path: "myOrder",
                    name: "我的订单",
                    component: myOrder,
                    meta: {
                        // isAuth: false,
                        isAuth: true,
                        type: 'company'
                    },
                },
                {
                    path: "deliver",
                    name: "发货管理",
                    component: deliver,
                    meta: {
                        isAuth: false,
                        type: 'company'
                    },
                },
                {
                    path: "jobPublish",
                    name: "职位发布效果",
                    component: jobPublish,
                    meta: {
                        isAuth: false,
                        type: 'company'
                    },
                },
                {
                    path: "resumeDown",
                    name: "简历下载情况",
                    component: resumeDown,
                    meta: {
                        isAuth: false,
                        type: 'company'
                    },
                },
                {
                    path: "refresh",
                    name: "职位刷新情况",
                    component: refresh,
                    meta: {
                        isAuth: false,
                        type: 'company'
                    },
                },
                {
                    path: "preview",
                    name: "简历预览",
                    component: minePreview,
                    meta: {
                        isAuth: true,
                        type: 'company'
                    },
                },
                // {
                //     path: "confirmOrder",
                //     name: "确认订单",
                //     component: confirmOrder,
                //     meta: {
                //         isAuth: true,
                //     },
                // },
                {
                    path: "myIntegral",
                    name: "我的积分",
                    component: myIntegral,
                    meta: {
                        isAuth: true,
                        type: 'company'
                    },
                },
                {
                    path: "serveOrder",
                    name: "服务订单",
                    component: serveOrder,
                    meta: {
                        isAuth: true,
                        type: 'company'
                    },
                },
                {
                    path: "integratingTask",
                    name: "积分任务",
                    component: integratingTask,
                    meta: {
                        isAuth: true,
                        type: 'company'
                    },
                },
                {
                    path: "exchangeService",
                    name: "兑换服务",
                    component: exchangeService,
                    meta: {
                        isAuth: true,
                        type: 'company'
                    },
                },

            ],
        },
        // 企业管理——网络招聘中心
        {
            path: "/network", //链接路径
            name: "网络招聘", //路由名称
            redirect: "/network/netCenter",
            component: network, //对应组件模板
            meta: {
                isAuth: false,
                type: 'company'
            },
            children: [{
                path: "netCenter",
                name: "网络招聘中心",
                component: networkCenter,
                meta: {
                    isAuth: false,
                    type: 'company'
                },
            },
                {
                    path: "postJob",
                    name: "发布职位",
                    component: postJob,
                    meta: {
                        isAuth: false,
                        type: 'company'
                    },
                },
                {
                    path: "jobList",
                    name: "职位列表",
                    component: jobList,
                    meta: {
                        isAuth: false,
                        type: 'company'
                    },
                },
                {
                    path: "jobTemplate",
                    name: "职位模板",
                    component: jobTemplate,
                    meta: {
                        isAuth: false,
                        type: 'company'
                    },
                },
                {
                    path: "netResume",
                    name: "简历库",
                    component: netResume,
                    meta: {
                        isAuth: false,
                        type: 'company'
                    },
                },
                {
                    path: "resumeSearch",
                    name: "简历搜索器",
                    component: resumeSearch,
                    meta: {
                        isAuth: false,
                        type: 'company'
                    },
                },
            ],
        },
        // 企业管理——现场招聘会
        {
            path: "/sceneMeet", //链接路径
            name: "现场招聘会", //路由名称
            redirect: "/sceneMeet/sceneCenter",
            component: sceneMeet, //对应组件模板
            meta: {
                isAuth: false,
                type: 'company'
            },
            children: [{
                path: "sceneCenter",
                name: "现场招聘会中心",
                component: sceneCenter,
                meta: {
                    isAuth: false,
                    type: 'company'
                },
            },
                {
                    path: "boothBooking",
                    name: "展位预订",
                    component: boothBooking,
                    meta: {
                        isAuth: false,
                        type: 'company'
                    },
                },
                {
                    path: "myBooth",
                    name: "我的展位",
                    component: myBooth,
                    meta: {
                        isAuth: false,
                        type: 'company'
                    },
                },
                {
                    path: "pastBooth",
                    name: "我的过期展位",
                    component: pastBooth,
                    meta: {
                        isAuth: false,
                        type: 'company'
                    },
                },
                {
                    path: "releaseJob",
                    name: "发布职称",
                    component: releaseJob,
                    meta: {
                        isAuth: false,
                        type: 'company'
                    },
                },
                {
                    path: "sceneJobList",
                    name: "职位列表",
                    component: sceneJobList,
                    meta: {
                        isAuth: false,
                        type: 'company'
                    },
                },
                {
                    path: "sceneJobListdel",
                    name: "职位回收站",
                    component: sceneJobListdel,
                    meta: {
                        isAuth: false,
                        type: 'company'
                    },
                },
                {
                    path: "receiveResume",
                    name: "收到的简历",
                    component: receiveResume,
                    meta: {
                        isAuth: false,
                        type: 'company'
                    },
                },
                // {
                //     path: "onlineInvitation",
                //     name: "在线邀请面试",
                //     component: onlineInvitation,
                // },
                {
                    path: "serviceManagement",
                    name: "服务管理",
                    component: serviceManagement,
                    meta: {
                        isAuth: false,
                        type: 'company'
                    },
                },
                {
                    path: "sceneInfo", //链接路径
                    name: "现场招聘会详情", //路由名称
                    component: sceneInfo,
                    meta: {
                        isAuth: false,
                        type: 'company'
                    },
                },
                // {
                //     path: "order", //链接路径
                //     name: "订单支付", //路由名称
                //     component: order,
                //     meta: {
                //         isAuth: false,
                //         type: 'company'
                //     },
                // },
                // {
                //     path: "orderSuccess", //链接路径
                //     name: "支付成功", //路由名称
                //     component: orderSuccess,
                //     meta: {
                //         isAuth: true,
                //     },
                // },
            ],
        },
    ],
});
// 全局路由守卫
routers.beforeEach((to, form, next) => {
    console.log(to, form, next)
    if (to.path.includes("/login")){
        if (form.path.includes("/login") === false&&form.path.includes('/nomRegister') === false&&form.path.includes('/firmRegister') === false) {
            let obj = {
                path: form.path,
                query: form.query
            }
            localStorage.setItem('pathUrl', JSON.stringify(obj));
        }
    }else {
        localStorage.removeItem('pathUrl');
    }
    if (window._hmt) {
        if (to.path) {
            window._hmt.push(['_trackPageview', '/#' + to.fullPath])
        }
    }
    if (to.meta.isAuth) {
        next()
    } else {
        if (Cookies.get('CompanyAuthorization') && to.meta.type == 'company' || Cookies.get('JobseekerAuthorization') && to.meta.type == 'mine') {
            next()
        } else {
            MessageBox.confirm("登陆已过期，请重新登录！", '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                next('/login')
            }).catch(() => {
                next('/')
            });

        }

    }
})
routers.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
})
//定义路由配置
export default routers;
